import React from "react";

// Компонент для відображення іконок
const Icon = ({ src, className = "" }) => (
  <span
    className={`icon mask ${className}`}
    style={{ maskImage: `url(${src})`, WebkitMaskImage: `url(${src})` }}
  />
);

export default Icon;
